// Fuente temporal para EST TK-11822. Mientras la API no exponga el check del
// maestro de prestadores, se pueden agregar aqui los codigos habilitados para
// probar el flujo. Al estar disponible Backend, esta lista puede quedar vacia:
// el helper prioriza el campo recibido en cada prestador.
const PRESTADORES_CON_ATENCION_VIRTUAL_TEMPORAL = [];

const CAMPOS_ATENCION_VIRTUAL = [
  "virtual",
  "atencionVirtual",
  "atencion_virtual",
  "atencionVirtualWeb",
];

const CAMPOS_COBERTURA_VIRTUAL_MUTUAL = [
  "atencionVirtual",
  "cubreAtencionVirtual",
  "permiteAtencionVirtual",
];

const CAMPOS_TEXTO_ATENCION_VIRTUAL = ["textoatencionvirtual"];

const esValorVerdadero = (valor) =>
  valor === true || valor === 1 || valor === "1" || valor === "true";

export const esTurnoVirtual = (turno) =>
  esValorVerdadero(obtenerCampo(turno, ["telemedicina"]));

const obtenerCampo = (objeto, campos) => {
  if (!objeto) {
    return undefined;
  }

  const campo = Object.keys(objeto).find((clave) =>
    campos.includes(clave.toLowerCase())
  );

  return campo ? objeto[campo] : undefined;
};

export const prestadorTieneAtencionVirtual = (prestador) => {
  if (!prestador) {
    return false;
  }

  const valorCampoBackend = obtenerCampo(
    prestador,
    CAMPOS_ATENCION_VIRTUAL.map((campo) => campo.toLowerCase())
  );

  if (valorCampoBackend !== undefined && valorCampoBackend !== null) {
    return esValorVerdadero(valorCampoBackend);
  }

  return PRESTADORES_CON_ATENCION_VIRTUAL_TEMPORAL.some(
    (codigo) => String(codigo) === String(prestador.codigo)
  );
};

export const obtenerConfiguracionAtencionVirtualMutual = (mutual) => ({
  cubreAtencionVirtual: esValorVerdadero(
    obtenerCampo(
      mutual,
      CAMPOS_COBERTURA_VIRTUAL_MUTUAL.map((campo) => campo.toLowerCase())
    )
  ),
  textoAtencionVirtual:
    obtenerCampo(mutual, CAMPOS_TEXTO_ATENCION_VIRTUAL) || "",
});

